<template>
  <div class="flex w-full items-center">
    <fieldset class="va-info-field-wrapper">
      <span class="va-input-label">{{ props.title }}</span>
      <div class="va-info-field-row" :class="props.class">
        <div class="va-info-field-wrapper-content">
          <div class="va-info-field-content">{{ props.content }}</div>
        </div>
        <div v-if="$slots.icon" class="slot-icon">
          <slot name="icon" />
        </div>
      </div>
    </fieldset>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  title: { type: String, default: "" },
  content: { type: String, default: "" },
  class: { type: String, default: "" },
})
</script>

<style scoped>
.va-info-field-wrapper {
  min-width: 100%;
  max-width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
}

.va-info-field-row {
  display: flex;
  align-items: center; /* Vertically align content and icon */
  justify-content: space-between; /* Space between content and icon */
  width: 100%;
}

.va-info-field-wrapper-content {
  flex: 1; /* Allow content to take up available space */
  padding-top: 8px;
  padding-bottom: 8px;
}

.slot-icon {
  display: flex;
  align-items: center; /* Vertically center the icon */
  justify-content: center;
  margin-left: 16px; /* Add spacing between content and icon */
}

.va-input-label {
  color: var(--va-primary);
  margin-bottom: 8px; /* Add spacing below the title */
  display: block; /* Ensure the title is on its own row */
}
</style>
